import Vue from 'vue'
import moment from 'moment'
import App from './App.vue'
import router, { menus } from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css' // 默认主题
// import './assets/css/theme-green/index.css' // 浅绿色主题
import 'font-awesome/css/font-awesome.min.css'
import 'normalize.css/normalize.css'
import './assets/css/icon.css'
import './components/common/directives' // 弹框拖拽属性
// 导入粘贴板插件
import VueClipboard from 'vue-clipboard2'
import { adminPermissions } from "@/api/admin"
import store from './store'
import { setStorage, getStorage, computePermission } from "@/utils/helper"
import CanvasPoster from 'vue-canvas-poster'
import axios from 'axios'
import './assets/css/fonts.css'



import 'katex/dist/katex.min.css'
import katex from 'katex'
const win = window;
win.katex = katex;




import '../public/static/UE/ueditor.config.js'
import '../public/static/UE/ueditor.all.js'
import '../public/static/UE/lang/zh-cn/zh-cn.js'
import '../public/static/UE/ueditor.parse.js'
import '../public/static/UE/themes/default/css/ueditor.css'
import '../public/static/UE/kityformula-plugin/addKityFormulaDialog.js'
import '../public/static/UE/kityformula-plugin/getKfContent.js'
import '../public/static/UE/kityformula-plugin/defaultFilterFix.js'
// 初始化 MathJax 配置
window.MathJax = {
  tex: {
    inlineMath: [['$', '$'], ['\\(', '\\)']],
    displayMath: [['$$', '$$'], ['\\[', '\\]']],
  },
  options: {
    ignoreHtmlClass: 'tex2jax_ignore',
  },
   startup: {
    ready() {
     window.MathJax.startup.defaultReady();
    },
  },
  
};

// 动态加载 MathJax 脚本
const script = document.createElement('script');
script.src = 'https://cdn.jsdelivr.net/npm/mathjax@3/es5/tex-mml-chtml.js';
script.async = true;
document.head.appendChild(script);
Vue.use(CanvasPoster)

Vue.config.productionTip = false

// 乐高编辑模式
Vue.prototype.$editor = true

Vue.use(VueClipboard)
Vue.prototype.$moment = moment

Vue.use(ElementUI, {
  size: 'small'
})

const eventBus = {
  install(Vue) {
    Vue.prototype.$bus = new Vue()
  }
}
Vue.use(eventBus)

//使用钩子函数对路由进行权限跳转
router.beforeEach((to, from, next) => {

  document.title = `${to.meta.title} | 研盒教育`
  const adminInfo = getStorage('admin_user')
  let permissions = getStorage('admin_permissions')
  const paths = []

  // vue 有效路由解构
  const parseRoutes = (routes) => {
    routes.forEach(item => {
      paths.push(item.path)
      if (item.children) {
        parseRoutes(item.children)
      }
    })
  }
  parseRoutes(router.options.routes)

  Vue.prototype.$axios = axios

  // 入口处理
  const computeNext = () => {
    if (adminInfo.username == 'admin') {
      next()
    } else {
      const isMatched = computePermission(to.matched[to.matched.length - 1].regex)
      if (isMatched) {
        next()
      } else {
        const permission = permissions.find(v => paths.includes(v.code))

        if (permission) {
          next(permission.code)
        } else {
          next('/404')
        }
      }
    }
  }

  if (to.path == '/login' || to.path == '/404') {
    next()
  } else {
    if (adminInfo) {
      if (permissions) {
        computeNext()
      } else {
        adminPermissions({ admin_id: adminInfo.id }).then(res => {
         
          setStorage("admin_permissions", res.list)
          permissions = res.list

          if (!res.list.length) {
            next(`/login?redirect=${to.path}`)
          } else {
            computeNext()
          }
        }).catch(err => {
          console.log(err)
          next(`/login?redirect=${to.path}`)
        })
      }
    } else {

      next(`/login?redirect=${to.path}`)
    }
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
